import React from 'react';
import { FormInput } from 'react-form';
import Select from 'react-select';

export default ( { field, suffixIcon, ...rest } ) => {
  return (
    field ?
      <FormInput field={field}>
        {( { setValue, getValue, setTouched } ) => {
          return (
            suffixIcon ?
              <div className="input-group">
                <Select
                  simpleValue={true}
                  searchable={true}
                  labelKey="name"
                  valueKey="id"
                  {...rest}
                  value={getValue()}
                  onChange={val => {
                    if( val !== getValue() ) {
                      setValue( val );
                      if( rest.onChange ) rest.onChange( val )
                    }
                  }}
                  onBlur={() => setTouched()}
                />
                {!!suffixIcon && <span className="input-group-addon pointer">{suffixIcon}</span>}
              </div> :
              <Select
                simpleValue={true}
                searchable={true}
                labelKey="name"
                valueKey="id"
                {...rest}
                value={getValue()}
                onChange={val => {
                  if( val !== getValue() ) {
                    setValue( val );
                    if( rest.onChange ) rest.onChange( val )
                  }
                }}
                onBlur={() => setTouched()}
              />
          )
        }}
      </FormInput>
      :
      <Select
        simpleValue={true}
        searchable={true}
        labelKey="name"
        valueKey="id"
        {...rest}
        onChange={val => {
          if( rest.onChange ) rest.onChange( val )
        }}
      />
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/Select/index.js